import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface MobileViewSelectorProps {
  activeTab: string;
  onTabChange: (value: string) => void;
}

export const MobileViewSelector = ({ activeTab, onTabChange }: MobileViewSelectorProps) => {
  return (
    <div className="mb-6">
      <Select value={activeTab} onValueChange={onTabChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select view" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="overview">Overview</SelectItem>
          <SelectItem value="progress">Progress</SelectItem>
          <SelectItem value="testing-modules">Testing Modules</SelectItem>
          <SelectItem value="tests">Test Results</SelectItem>
          <SelectItem value="milestones">Milestones</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};